import type { FormFieldInterface } from "../dom/form";
import { HCBase, type ApiMap } from "../hc/base";
import { FormField as FormFieldV4 } from "./form";

export class HCv4 extends HCBase {
  readonly FormField = FormFieldV4;

  constructor(apiDeps: ApiMap | null) {
    super("v4", apiDeps);
  }

  protected createField(_identifier: string): FormFieldInterface {
    throw new Error("FormField is not yet implemented for HC v4");
  }

  getAllArticles(): Promise<any> {
    const articles = this.use("articles");
    return articles.getAll();
  }

  searchForArticle(query: string): Promise<any> {
    const articles = this.use("articles");
    return articles.searchArticle(query);
  }
}
